(function () {
  var SECTION_SELECTOR = '.oddit-section-scientific-benefits-hero';

  function initSection(section) {
    var cards = section.querySelector('.oddit-section-scientific-benefits-hero__cards');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');

    if (!cards || !prevBtn || !nextBtn) return;

    function getStep() {
      var firstCard = cards.querySelector('.oddit-section-scientific-benefits-hero__card');
      if (!firstCard) return cards.clientWidth;
      return firstCard.getBoundingClientRect().width - 1;
    }

    function scrollByStep(direction) {
      var step = getStep();
      cards.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    function updateNavState() {
      var maxScroll = cards.scrollWidth - cards.clientWidth;
      var atStart = cards.scrollLeft <= 1;
      var atEnd = cards.scrollLeft >= maxScroll - 1;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function onPrev() { scrollByStep(-1); }
    function onNext() { scrollByStep(1); }

    prevBtn.addEventListener('click', onPrev);
    nextBtn.addEventListener('click', onNext);
    cards.addEventListener('scroll', updateNavState, { passive: true });

    updateNavState();

    section._oddit_destroy = function () {
      prevBtn.removeEventListener('click', onPrev);
      nextBtn.removeEventListener('click', onNext);
      cards.removeEventListener('scroll', updateNavState);
    };
  }

  function destroySection(section) {
    if (section && typeof section._oddit_destroy === 'function') {
      section._oddit_destroy();
      section._oddit_destroy = null;
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();